var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5",
    transform: "translate(5.25 5.25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,13h-6V7H13v6H7v1.5h6v6h1.5v-6h6Z",
    transform: "translate(-7 -7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,11.987,11.987,0,0,0,12,0Zm0,22.5A10.5,10.5,0,1,1,22.5,12,10.629,10.629,0,0,1,12,22.5Z",
    transform: "translate(-5.25 -5.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSmall);
export default __webpack_public_path__ + "static/media/plus-small.cae8715b40a7dbd06908dbf5f7d1ecfe.svg";
export { ForwardRef as ReactComponent };